import { IVec3 } from "@base/math/Vec3";

export enum MonthShort {
  Jan,
  Feb,
  Mar,
  Apr,
  May,
  Jun,
  Jul,
  Aug,
  Sep,
  Oct,
  Nov,
  Dec,
}

export interface IOrbitControlsState {
  target: IVec3;
  position: IVec3;
  zoom: number;
}

export interface IEnvironmentSettingsNone {
  type: "none";
}

export interface IEnvironmentSettingsUseBackground {
  type: "useBackground";
}

export interface IEnvironmentSettingsColor {
  type: "color";
  color: string;
  strength: number;
}

export interface IEnvironemntSettingsTexture {
  type: "texture";
  textureUrl: string;
  strength: number;
}

export interface IEnvironmentSettingsCustomTexture {
  type: "customTexture";
  blob: Blob | undefined;
  name: string;
  strength: number;
}

export type EnvironmentSettings = IEnvironmentSettingsNone | IEnvironmentSettingsColor | IEnvironemntSettingsTexture | IEnvironmentSettingsCustomTexture | IEnvironmentSettingsUseBackground;